/**
 * scroll事件 懒加载
 */
// 队列
const queues = {};
// 事件
let isScroll = false;
// 绑定方法
let lazyThrottle = null;

const lazy = {
    // 返回IntersectionObserver，以便兼容
    bindScroll() {
        return () => {
            return {
                unobserve: vm => {
                    this.removeScroll(vm);
                },
                // dom，组件vm
                observe: vm => {
                    this.addScroll(vm);
                }
            };
        };
    },
    // 绑定scroll事件，及添加组件队列
    addScroll(vm) {
        if (!lazyThrottle) {
            lazyThrottle = this.throttle(this.lazyLoad(), 500);
        }
        queues[vm._uid + '_lazy'] = vm;
        if (!isScroll) {
            isScroll = true;
            window.addEventListener('scroll', lazyThrottle);
        }
    },
    // 删除scroll事件，及删除组件队列
    removeScroll(vm) {
        delete queues[vm._uid + '_lazy'];
        const queuesLength = Object.keys(queues || {}).length;
        if (queuesLength === 0) {
            window.removeEventListener('scroll', lazyThrottle);
            isScroll = false;
        }
    },
    // 节制次数
    throttle(callback, delay) {
        let timeout = null;
        let startTime = new Date();
        return function() {
            const curTime = new Date();
            // eslint-disable-next-line
            clearTimeout(timeout);
            // 如果达到了规定的触发时间间隔，触发 handler
            if (curTime - startTime >= delay) {
                callback();
                startTime = curTime;
            } else {
                // 没达到触发间隔，重新设定定时器
                timeout = setTimeout(callback, delay);
            }
        };
    },
    // 执行队列中参数； root增加scroll事件判断
    // a：操作队列，无需绑定
    lazyLoad() {
        return () => {
            const innerHeight = window.innerHeight;
            // 可见区域底部
            const visibleBottom = window.scrollY + innerHeight;
            // 滚动懒加载 队列
            for (const key in queues) {
                if (queues.hasOwnProperty(key)) {
                    const vm = queues[key];
                    if (vm.$el.offsetTop < visibleBottom) {
                        vm.intersectionHandler([
                            {
                                isIntersecting: true,
                                intersectionRatio:
                                    (visibleBottom - vm.$el.offsetTop) /
                                    innerHeight
                            }
                        ]);
                    }
                }
            }
        };
    }
};

export default lazy;



// WEBPACK FOOTER //
// ./src/components/vue-lazy-component/lazy-scroll.js